import type {CellRendererProps} from '../types/CellRendererProps';
import type {CellStyle} from '../types/CellStyle';

export function getStylesToRender<S = CellStyle>(
  cellRendererProps: CellRendererProps
): S | undefined {
  const column = cellRendererProps.column;
  const data = cellRendererProps.row;

  if (column) {
    return (data[column.field] as {style?: unknown} | null)?.style as S | undefined;
  }
}
